export default __webpack_public_path__ + "static/media/verification.85458a85.svg";